var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 29,
    viewBox: "0 0 14 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.675 28.0025C11.3762 28.0035 11.081 27.9376 10.811 27.8095C10.541 27.6815 10.3032 27.4945 10.115 27.2625L0.454976 15.2625C0.160813 14.9046 0 14.4558 0 13.9925C0 13.5293 0.160813 13.0804 0.454976 12.7225L10.455 0.722505C10.7945 0.314071 11.2823 0.0572224 11.8111 0.008463C12.34 -0.0402965 12.8665 0.123027 13.275 0.462504C13.6834 0.801982 13.9403 1.2898 13.989 1.81866C14.0378 2.34751 13.8745 2.87407 13.535 3.2825L4.59498 14.0025L13.235 24.7225C13.4795 25.0161 13.6349 25.3736 13.6827 25.7527C13.7304 26.1317 13.6686 26.5166 13.5045 26.8617C13.3404 27.2067 13.0808 27.4975 12.7566 27.6997C12.4324 27.9019 12.057 28.007 11.675 28.0025Z",
    fill: "#373473"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevScreen);
export default __webpack_public_path__ + "static/media/prev_screen.c12ac7c466b9bb9e9bcca8233f6bd775.svg";
export { ForwardRef as ReactComponent };